import React from 'react'
import { useParams } from 'react-router-dom'

import messages from '../services/messages'
import StoreContext from '../store/Context'
import api from '../services/api'
import Data from '../components/organisms/panels/data'
import TreeOfKnowledge from '../components/organisms/panels/treeOfKnowledge'

const Undock = () => {
  const { panel } = useParams()
  const { token } = React.useContext(StoreContext)

  api.defaults.headers.common.Authorization = token
  messages.defaults.headers.common.Authorization = token

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
        }}
      >
        {panel === 'treeOfKnowledge' && <TreeOfKnowledge />}
        {panel === 'data' && <Data />}
      </div>
    </>
  )
}

export default Undock
